import React, { Component } from 'react';


import LineComponent from './../components/ChartLineDashboard/LineComponent';
import './../../selections/timeSelection/components/timeSelect/cliente.css';

import { colors } from './datos'
// 
//Actualizacion develop
class LineDB extends Component {

  render() {
    const { data, name, title, date } = this.props;

    return (
      <LineComponent
        name={name}
        title={title}
        data={data}
        date={date}
        onClickGraphic={this.props.onClickGraphic}
        seeMore={this.props.seeMore}
        openDialog={this.props.openDialog}
        colors={colors}
      />
    );
  }
}

export default LineDB;